import { render, staticRenderFns } from "./Top10BorcluCariListesi.vue?vue&type=template&id=538304e4&scoped=true"
import script from "./Top10BorcluCariListesi.vue?vue&type=script&lang=js"
export * from "./Top10BorcluCariListesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538304e4",
  null
  
)

export default component.exports